import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Global from '../../../../store/global-selectors';
import messages from '../messages';
import PackageColumn from '../../../../components/columns/package-column';

const InternationalPackageColumn = ({ id: presetGroupId }) => {
  const internationalPackageId = useSelector((state) =>
    Global.selectEntitiesPresetGroupPropertyById(state, {
      profileId: presetGroupId,
      property: 'intlPackageTypeId',
    }),
  );

  return <PackageColumn packageTypeId={internationalPackageId} />;
};

InternationalPackageColumn.propTypes = {
  id: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: messages.internationalPackageColumn,
  name: <FormattedMessage {...messages.internationalPackageColumn} />,
  id: 'internationalPackage',
  isSortable: false,
  render: InternationalPackageColumn,
};
